import axios from "axios";
import config from "../config/config";
import { apiHelper } from "../utils/apiHelper";

const _endpoint = `/api/scheduling`;

export const schedulingApi = {
  getSchedulingByJobId: (jobId) => {
    return axios(`${_endpoint}/${jobId}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "get",
    })
      .then((result) => result.data)
      .catch((err) => {
        if (err?.response?.status === 404) {
          return null;
        }
        apiHelper.handleError(err);
      });
  },
  createScheduling: (jobId, data) => {
    return axios(`${_endpoint}/${jobId}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data,
    })
      .then((result) => result.data)
      .catch((err) => apiHelper.handleError(err));
  },
  updateScheduling: (jobId, data) => {
    return axios(`${_endpoint}/${jobId}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "put",
      data,
    })
      .then((result) => result.data)
      .catch((err) => apiHelper.handleError(err));
  },
};
